import { defineAction } from '~/prix'
import residenceCreateAction from './residenceCreate.action.json' with { type: 'json' }
import { residenceObject } from '../residenceObject'
import { z } from 'zod'

const residenceCreateDefinition = defineAction({
  ...residenceCreateAction,

  input: residenceObject
    .pick({
      id: true,
      plusCode: true,
      title: true,
      observation: true,
      isRural: true,
      monitoredLocation: true,
      latitude: true,
      longitude: true,
      accuracy: true,
      communityId: true,
      buildingId: true,
      fullAddress: true,
      complement: true,
      referencePoint: true,
      wifiSsid: true,
      wifiPassword: true,
      createdAt: true,
      updatedAt: true,
    }),
  output: z.object({ residenceCustomCode: z.string().nullish() }),
})

export default residenceCreateDefinition
